import React, { useEffect, useState, VoidFunctionComponent } from "react";
import { BottomLayout } from "@/components/responsive/product/layer/bottomLayout/BottomLayout";
import { Button } from "@/components/responsive/commun/button";
import { LAYER_TYPE } from "@/utils/constants";
import { QuestionAnswerBlock } from "@/components/responsive/product/layer/question/QuestionAnswerBlock";
import { pluralize } from "@/utils/responsive/utils";
import { ProductReviewQuestions } from "@/models/scope/productSheet/ProductReviewQuestions";
import { Question } from "@/assets//images/responsive/icons/question";
import { RatingBar } from "@/components/responsive/product/layer/rating/RatingBar";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '@/models/appState/RootState';
import { loadQuestions } from "@/redux/reducers/responsive/product/questionsAction";

interface Props {
    reviewQuestions: ProductReviewQuestions;
    setLayerType: (layerType: string) => void;
    productId: string
}

const INITIAL_COUNT = 0;
const QUESTION_STEP = 5;
const getInitialCount = (count: number) => {
    const totalNumber = count;
    if (!totalNumber) {
        return 0;
    }
    if (totalNumber > QUESTION_STEP) {
        return QUESTION_STEP;
    }
    return totalNumber;
};
const updateCount = (initialValue: number, totalValue: number) => {
    if (!initialValue || !totalValue) {
        return 0;
    }
    if (initialValue + QUESTION_STEP < totalValue) {
        return initialValue + QUESTION_STEP;
    }
    return totalValue;
};
export const QuestionLayer: VoidFunctionComponent<Props> = ({ reviewQuestions, setLayerType, productId }) => {
    const [numberOfQuestionToDisplay, setNumberOfQuestionToDisplay] = useState(INITIAL_COUNT);
    const dispatch = useDispatch();
    const questionsData = useSelector((state: RootState) => state.questions);

    const { summary, items } = reviewQuestions;
    const { questionsCount, answersCount } = summary;
    const productQuestionListData = questionsData.changeQuestionsFromClient ? questionsData.items : items;

    useEffect(() => {
        setNumberOfQuestionToDisplay(getInitialCount(questionsCount));
    }, [questionsCount]);

    const handleDisplayMoreQuestion = () => {
        setNumberOfQuestionToDisplay(updateCount(numberOfQuestionToDisplay, questionsCount));
        dispatch(loadQuestions({
            productId: productId,
            pageIndex: questionsData.pageIndex,
            reviewQuestionsItems: productQuestionListData
        }));
    };
    return (
        <div className='question-layer'>
            <div className='content'>
                <p className='header'>
                    {`${questionsCount} ${pluralize(questionsCount, 'question')} / `}
                    <span className='in-bold'>{answersCount} {pluralize(answersCount, 'réponse')}</span>
                </p>

                {productQuestionListData.map((question) => <QuestionAnswerBlock question={question}
                    key={question.questionId} />)}

                <div className='bottom'>
                    {questionsCount != 0 && <div className='bottom-more-question'>
                        <p>
                            Vous avez vu {numberOfQuestionToDisplay} {questionsCount > 1 ? "questions" : "question"} sur {questionsCount || 0}
                        </p>
                        <RatingBar
                            count={String(numberOfQuestionToDisplay)}
                            totalCount={questionsCount.toString() || '0'}
                            reviewsProgression
                        />
                        {numberOfQuestionToDisplay < questionsCount && (
                            <div
                                className='bottom-button'
                                onClick={() => handleDisplayMoreQuestion()}
                            >
                                Voir plus
                            </div>
                        )}
                    </div>}
                </div>
            </div>
            <BottomLayout>
                <div className='bottom-button'>
                    <Button
                        type='adaptive'
                        enabled
                        callBack={() => setLayerType(LAYER_TYPE.ASK_QUESTION)}
                    >
                        <div className='button-label'>
                            <Question />
                            <p className='uppercase'>Poser une question</p>
                        </div>
                    </Button>
                </div>
            </BottomLayout>
        </div>
    );
};